/* LJV — Abgespeckte Summenleiste auf der Warenkorbseite.
 *
 * Zeigt am unteren Rand nur Gesamtsumme und Kasse, solange die vollstaendige Uebersicht
 * ausserhalb des Sichtfelds liegt. Sobald man weit genug gescrollt hat, verschwindet die
 * Leiste und die Uebersicht uebernimmt — nie beides gleichzeitig.
 *
 * Warum nicht position:sticky: dabei bleibt die Leiste am Rand stehen, waehrend die
 * Uebersicht schon sichtbar ist. Genau die Dopplung soll ja weg.
 *
 * Ohne Skript bleibt die Leiste durch das hidden-Attribut im Markup unsichtbar. Die Seite
 * verhaelt sich dann wie ohne Leiste — harmlos, weil die Uebersicht ohnehin alles traegt.
 * Deshalb steht hier auch kein Netzwerkaufruf und nichts, was fehlschlagen koennte.
 */
(function () {
  'use strict';

  var BREAKPOINT = '(max-width: 999px)';

  var LjvCartSticky = class extends HTMLElement {
    connectedCallback() {
      this.summary = document.querySelector('.ljv-cart__summary');
      this.media = window.matchMedia(BREAKPOINT);

      if (!this.summary || !('IntersectionObserver' in window)) return;

      this.onChange = this.onChange.bind(this);
      this.observer = new IntersectionObserver(this.onChange, { threshold: 0 });

      this.apply = this.apply.bind(this);
      this.media.addEventListener('change', this.apply);
      this.apply();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.media) this.media.removeEventListener('change', this.apply);
    }

    apply() {
      this.observer.disconnect();

      // Auf breiten Schirmen steht die Uebersicht dauerhaft daneben, dort braucht es nichts.
      if (!this.media.matches) {
        this.hidden = true;
        return;
      }

      // Der Beobachter meldet nur Aenderungen. Liegt die Uebersicht beim Laden bereits im
      // Bild — kurze Warenkoerbe, hohe Schirme —, bliebe die Leiste sonst faelschlich stehen.
      this.setFromPosition();
      this.observer.observe(this.summary);

      // Nach dem Laden der Bilder verschiebt sich das Layout noch einmal.
      if (document.readyState !== 'complete') {
        window.addEventListener('load', this.setFromPosition.bind(this), { once: true });
      }
    }

    setFromPosition() {
      var box = this.summary.getBoundingClientRect();
      var visible = box.top < window.innerHeight && box.bottom > 0;
      this.hidden = visible;
    }

    onChange(entries) {
      // Sichtbare Uebersicht heisst: der Nutzer ist am Ziel, die Leiste hat sich erledigt.
      this.hidden = entries[0].isIntersecting;
    }
  };

  if (!window.customElements.get('ljv-cart-sticky')) {
    window.customElements.define('ljv-cart-sticky', LjvCartSticky);
  }
})();
